import { Component } from '@angular/core';

@Component({
  selector: 'rfm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'rfm-software';
}
